<label
  class="myre-switch"
  [class.with-label]="withLabel"
  [class.fit-height]="fitHeight"
  [class.with-background]="withBackground"
  [class.disabled]="disabled"
  [class.readonly]="readonly"
>
  <input
    type="checkbox"
    [ngModel]="checked"
    [disabled]="disabled || readonly"
    (ngModelChange)="onChange($event)"
  />
  @if (label) {
    <span class="myre-form__label">{{ label | translate }}</span>
  }

  <span class="myre-switch__wrapper">
    @if (questionMarkTooltip) {
      <myre-icon-tooltip [label]="questionMarkTooltip" />
    }

    @if (checked ? onLabel : offLabel) {
      <span class="myre-switch__wrapper__value">{{
        (checked ? onLabel : offLabel) | translate
      }}</span>
    }

    <span class="myre-switch__wrapper__container" [class.checked]="checked">
      <span class="myre-switch__wrapper__container__thumb"></span>
    </span>
  </span>
</label>
